export const eventColors: Record<string, string> = {
    LABELING: '#626ae2',
    INTRODUCTION: '#2b7fff',
    AGGREGATION: '#0891b2',
    DEAGGREGATION: '#f43f5e',
    SHIPPING: '#efb100',
    RECEIVING: '#00c16a',
    SHIPMENT_REJECTION: '#be123c',
    TRANSPORTATION: '#f97316',
    RETAIL_SALE: '#0d9488',
    DECOMMISSIONING: '#fb2c36',
    RETURN_FROM_CONSUMER: '#84cc16',
    RELABELING: '#a855f7',
};
export const eventColor = (kind: string) => eventColors[kind] || '#0f172b';
